





































import {
  defineComponent,
  reactive,
  computed,
  ref,
  watch
} from "@vue/composition-api";
import OccIcon from "@/components/Atoms/OccIcon/index.vue";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";
import LoadingContainer from "@/components/Pages/Scout/elements/LoadingContainer/index.vue";
import ListTable, { Props } from "@/components/Molecules/ListTable/index.vue";
import MessageTemplateRow from "@/components/Pages/Scout/MessageTemplates/MessageTemplateList/MessageTemplateRow/index.vue";
import {
  TemplateRow,
  TableSort
} from "@/components/Pages/Scout/MessageTemplates/MessageTemplateList/MessageTemplateRow/types";
import MessageTemplateRightDrawer from "@/components/Pages/Scout/MessageTemplates/MessageTemplateRightDrawer/index.vue";
import { updateMessageTemplate } from "@/grpc-web/scout/message_template";
import { MessageTemplate } from "@/components/Pages/Scout/MessageTemplates/MessageTemplateRightDrawer/MessageTemplatePanel/types";

export default defineComponent({
  name: "MessageTemplateList",
  components: {
    ListTable,
    OccIcon,
    OccHeading,
    MessageTemplateRow,
    LoadingContainer,
    MessageTemplateRightDrawer
  },
  props: {
    templates: {
      type: Array as () => TemplateRow[],
      default: () => []
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    shouldClose: {
      type: Boolean,
      default: false
    }
  },
  emits: ["delete", "edit"],
  setup(props, { emit }) {
    const headers = reactive<Props<{ sortParam: TableSort }>["headers"]>([
      {
        name: "テンプレート名",
        minSizeContainer: "900px"
      }
    ]);
    const headerText = ref("テンプレート編集");

    watch(
      () => props.shouldClose,
      newValue => {
        if (newValue !== undefined) {
          isShowMessageTemplateDrawer.value = false;
        }
      }
    );

    const tableRows = computed(() => {
      const rows = props.templates?.map(template => {
        return {
          id: template.id,
          title: template.title,
          message: template.message
        };
      });
      return rows;
    });

    const isShowMessageTemplateDrawer = ref(false);

    const handleClickedDelete = (templateRow: TemplateRow) => {
      emit("delete", templateRow);
    };

    const selectedTemplate = ref<TemplateRow | null>(null);
    const handleClickedEdit = (id: number) => {
      const template: TemplateRow | undefined = tableRows.value.find(
        v => v.id === id
      );
      if (template) {
        emit("close-new-template");
        selectedTemplate.value = template;
        isShowMessageTemplateDrawer.value = true;
      }
    };

    const handleClickedRow = (value: any, index: number) => {
      handleClickedEdit(props.templates[index].id);
    };

    const handleClickedSave = async (template: MessageTemplate) => {
      await updateMessageTemplate(
        template.id as number,
        template.name,
        template.body
      ).finally(() => {
        isShowMessageTemplateDrawer.value = false;
      });

      emit("update");
    };

    const handleClickedCancel = () => {
      isShowMessageTemplateDrawer.value = false;
    };

    const handleMouseOverMessageTemplateDrawer = () => {
      emit("mouseover");
    };

    const handleMouseLeaveMessageTemplateDrawer = () => {
      emit("mouseleave");
    };

    const handleMouseOverTableHeader = () => {
      emit("mouseover-header");
    };

    const handleMouseLeaveTableHeader = () => {
      emit("mouseleave-header");
    };

    return {
      headers,
      tableRows,
      isShowMessageTemplateDrawer,
      headerText,
      selectedTemplate,
      handleClickedDelete,
      handleClickedEdit,
      handleClickedCancel,
      handleClickedSave,
      handleClickedRow,
      handleMouseOverMessageTemplateDrawer,
      handleMouseLeaveMessageTemplateDrawer,
      handleMouseOverTableHeader,
      handleMouseLeaveTableHeader
    };
  }
});
